import { useMemo, useState } from 'react'

const useComplaintFilter = (sortedComplaints) => {
  const [filterStatus, setFilterStatus] = useState(null)

  const onFilterStatusChange = (value) => setFilterStatus(value)

  const filteredComplaintResult = useMemo(
    () =>
      filterStatus
        ? sortedComplaints?.filter((order) => {
            const filteredFieldsWithValues = Object.entries(filterStatus)
            return filteredFieldsWithValues.some(
              (entry) =>
                entry[1]?.length === 0 || entry[1]?.includes(order[entry[0]])
            )
          })
        : sortedComplaints,
    [filterStatus, sortedComplaints]
  )

  return {
    filteredComplaints: filteredComplaintResult,
    onFilterStatusChange,
    filterStatus
  }
}

export default useComplaintFilter
